import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { DepartmentDetailsWrapper } from "./styled";
import {
  BackButton,
  Box,
  HeadingStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import { Col, Row } from "react-bootstrap";
import { FormDataContainer } from "../settings/styled";
import ViewPage from "../../../components/common/pageView/pageView";
import HQBranchesApi from "../../../services/api/hqBranchesApi";

const DepartmentDetails = () => {
  const { t, i18n: {language} } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParam = new URLSearchParams(location.search);
  const hqBranchId = searchParam.get("org-structure");
  const departmentId = searchParam.get("department");

  const [departmentDetails, setDepartmentDetails] = useState({});
  const [loading, setLoading] = useState(false);

  const getSingleDepartment = async () => {
    try {
      setLoading(true);
      const { data, code } = await HQBranchesApi.getSingleDepartment(
        hqBranchId,
        departmentId
      );
      if (code === 200) {
        setDepartmentDetails(data);
      }
      if (code === 204 || code === 100) {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSingleDepartment();
  }, []);

  return (
    <DepartmentDetailsWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("view_department")}
            onClick={() =>
              navigate(`/org-structure/departments?org-structure=${hqBranchId}`)
            }
          />
          <Breadcrumbs />
        </Box>
      </Box>
      <Box className="content-container">
        {loading ? (
          <ThemeLoader />
        ) : (
          <Row className="mt-3">
            <Col md={12} className="mb-4">
              <FormDataContainer className="dataContainer">
                <ViewPage
                  label={t("name_en")}
                  text={departmentDetails.name_en}
                />
                <ViewPage
                  label={t("name_ar")}
                  text={departmentDetails.name_ar}
                />
                <ViewPage
                  label={t("initial_name")}
                  text={departmentDetails.initial_name}
                />
              </FormDataContainer>
            </Col>
            <Col md={12} className="mb-4">
              <HeadingStyled
                size="20px"
                weight="400"
                color="var(--text)"
                className="mb-2"
              >
                {t("location")}
              </HeadingStyled>
              <FormDataContainer className="dataContainer">
                <ViewPage
                  label={t("City")}
                  text={
                    language === "en"
                      ? departmentDetails?.city?.en_name
                      : departmentDetails?.city?.ar_name
                  }
                />
                <ViewPage
                  label={t("building")}
                  text={departmentDetails.building}
                />
                <ViewPage label={t("floor")} text={departmentDetails.floor} />
                <ViewPage label={t("office")} text={departmentDetails.office} />
                <ViewPage
                  label={t("address")}
                  text={departmentDetails.address}
                />
              </FormDataContainer>
            </Col>
            <Col md={12} className="mb-4">
              <HeadingStyled
                size="20px"
                weight="400"
                color="var(--text)"
                className="mb-2"
              >
                {t("contact")}
              </HeadingStyled>
              <FormDataContainer className="dataContainer">
                <ViewPage
                  label={t("contact_number")}
                  text={departmentDetails.contact_no}
                />
                <ViewPage
                  label={t("contact_email")}
                  text={departmentDetails.email}
                />
              </FormDataContainer>
            </Col>
          </Row>
        )}
      </Box>
    </DepartmentDetailsWrapper>
  );
};

export default DepartmentDetails;
